import { useNavigate } from "react-router-dom-v5-compat";

import { useTypedState } from "seneca-common/utils/routing/react-router-typesafe-routes/dom";

import useGetOneToOneTutoringSourceParam from "features/parents/pages/tutoring-page/hooks/useGetOneToOneTutoringSourceParam";
import { MODAL_ROUTES } from "routing/routes";

import { TutoringFormModalStep } from "../consts";
import { getNavigateToOneTutoringFormModalOptions } from "../utils/links";

export default function useGoToStep() {
  const navigate = useNavigate();
  const oneToOneTutoringSource = useGetOneToOneTutoringSourceParam();
  const { background, childId } = useTypedState(
    MODAL_ROUTES.TUTORING_FORM_JOURNEY
  );

  const goToStep = (step: TutoringFormModalStep) => {
    const { to, state } = getNavigateToOneTutoringFormModalOptions({
      step,
      childId,
      backgroundLocation: background,
      oneToOneTutoringSource
    });

    navigate(to, { state });
  };

  return goToStep;
}
